import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Heart, Shield, Users, Sparkles, ArrowRight, Star } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import getCanonicalUrl from '../utils/canonical';
import StructuredData from '../components/StructuredData';

const Home = () => {
  const benefits = [
    {
      icon: Users,
      title: 'Incontri Reali',
      description: 'Solo persone vere, verificate e motivate. Niente profili falsi o perdite di tempo.'
    },
    {
      icon: Shield,
      title: 'Profili Certificati',
      description: 'Ogni iscritto è verificato e certificato. Massima discrezione e sicurezza garantita.'
    },
    {
      icon: Heart,
      title: 'Supporto Umano',
      description: 'Un team di esperti vi accompagna in ogni fase, con consulenza personalizzata.'
    },
    {
      icon: Sparkles,
      title: 'Selezione di Qualità',
      description: 'Presentiamo solo profili compatibili. Qualità prima della quantità.'
    }
  ];

  const testimonials = [
    "Agenzia di forte sussidio a chi vuole realmente incontrare la persona del cuore! Non apposta il suo nome né fa da garanzia e il Sig. Dario è una persona dal cuore d'oro sensibile ad ogni esigenza di chi realmente è interessato a tale incontro! E Grazie a Dario ho incontrato la persona della mia Vita!",
    "Grande professionalità, competenza, serietà, disponibilità, passione e senso dell'umanità contraddistinguono il club, persone empatiche e gentili, abilissimi a capire la psicologia delle persone. Ho avuto un'esperienza positivissima, grazie alla quale sono riuscito in breve tempo a realizzare il mio sogno! Consiglio vivamente di affidarsi a loro!!",
    "Seri e professionale. Ho realizzato in poco tempo il sogno di costruire una famiglia, avendo trovato una compagna di cui sono innamorato. Dario è una persona brava e molto empatica. Consigliata vivamente!",
    "Dei veri e propri professionisti, li consiglierei a tutti e non li ringrazierò mai abbastanza.",
    "Ho iniziato questa esperienza essendo un po' scettico, ho conosciuto Dario che mi ha spiegato tutto il percorso da seguire. Alla fine posso dire che consiglio vivamente questa esperienza per la serietà dell'agenzia e di chi la gestisce. Ancora un grazie di cuore a Dario e tutti i suoi collaboratori per il lavoro svolto. P. S. Ho trovato la mia metà.",
    "Porto la mia esperienza farne garante di quanto è valido l'aiuto del Club per Single Officine del Cuore",
    "Un'esperienza davvero speciale: ho trovato non solo grande professionalità, ma soprattutto empatia e ascolto sincero. Mi sono sentito accolta, compresa e seguita con molta attenzione in ogni passo. È raro incontrare una persona come Dario che lavora con così tanta sensibilità e rispetto per le emozioni degli altri. Consiglio questa agenzia a chi cerca qualcosa di serio e autentico.",
    "Ottima agenzia. Professionalità empatia che rappresenta Dario che gestisce le emozioni con tanta anima e cuore",
    "Esperienza molto positiva. Lo staff è gentile, professionale e attento alle esigenze delle persone. Mi sono sentita ascoltata e accompagnata con serietà durante tutto il percorso. Consigliata a chi cerca un servizio serio per conoscere nuove persone.",
    "Ottima agenzia lavorano scrupolosamente, sono soddisfatta di averla scelta grazie ancora",
    "Mi sono rivolto a questa agenzia per aiutarmi a trovare la giusta compagna e devo dire che sono stati all'altezza delle aspettative. Ho trovato la giusta professionalità e tanti fatti. Complimenti"
  ];

  return (
    <div className="home-page">
      <Helmet>
        <title>Migliore Agenzia Matrimoniale | Officine del Cuore</title>
        <meta name="description" content="Agenzia Matrimoniale e di incontri seri a Napoli, Caserta, Roma. Oltre 18 anni di esperienza. Single verificati, incontri selezionati e massima riservatezza" />
        <link rel="canonical" href={getCanonicalUrl('/')} />
      </Helmet>
      <StructuredData type="all" />

      {/* Hero Section */}
      <section className="hero-section" style={{backgroundImage: 'url(https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/qorwrc2n_Gemini_Generated_Image_xdoy0rxdoy0rxdoyNapoli.png)'}}>
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="max-w-4xl mx-auto text-center px-4">
            <h1 className="hero-title fade-in">
              L'amore non è un caso.<br />È un incontro guidato.
            </h1>
            <h2 className="hero-subtitle-cities fade-in-delay">
              Napoli - Caserta - Roma
            </h2>
            <p className="hero-subtitle fade-in-delay">
              Da 19 anni creiamo connessioni autentiche tra persone che desiderano una relazione seria e duratura.
              Non siamo un'app. Siamo un'agenzia matrimoniale che crede nell'importanza dell'ascolto e della selezione umana.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8 fade-in-delay-2">
              <Link to="/contatti">
                <Button size="lg" className="btn-primary btn-large">
                  Richiedi un Colloquio Riservato
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
              <Link to="/come-funziona">
                <Button size="lg" className="btn-primary btn-large">
                  Scopri Come Funziona
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Bar */}
      <section className="trust-bar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="trust-item">
              <div className="trust-number">19+</div>
              <div className="trust-label">Anni di Esperienza</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">1500+</div>
              <div className="trust-label">Coppie Felici</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">100%</div>
              <div className="trust-label">Riservatezza</div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="section-elegant">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="section-title">
            Benvenuti nelle Officine del Cuore
          </h2>
          <p className="section-description">
            Siamo un'agenzia matrimoniale con sede a <strong>Napoli, Caserta</strong> e <strong>Roma</strong>, 
            specializzata da oltre 19 anni in incontri seri e relazioni durature. 
            Il nostro approccio è diverso: non facciamo numeri, creiamo connessioni autentiche.
          </p>
          <p className="section-description">
            Ogni persona che entra a far parte di Officine del Cuore viene ascoltata, compresa e accompagnata 
            con discrezione e professionalità. Perché l'amore non è un algoritmo: è un'esperienza umana.
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section-benefits">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="section-title text-center mb-12">
            Perché Scegliere Officine del Cuore
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit) => (
              <Card key={benefit.title} className="benefit-card">
                <CardContent className="p-6">
                  <div className="benefit-icon-wrapper">
                    <benefit.icon className="benefit-icon" />
                  </div>
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Difference Section */}
      <section className="section-elegant bg-warm-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="section-title text-center mb-12">
            La Differenza tra Noi e le App di Dating
          </h2>
          <div className="comparison-grid">
            <div className="comparison-column">
              <h3 className="comparison-title negative">App di Dating</h3>
              <ul className="comparison-list">
                <li>Centinaia di profili senza filtro</li>
                <li>Nessuna verifica dell'identità</li>
                <li>Swipe infiniti e conversazioni vuote</li>
                <li>Algoritmi che decidono per te</li>
                <li>Perdita di tempo e frustrazione</li>
                <li>Riservatezza zero, profilo e immagine pubblica</li>
              </ul>
            </div>
            <div className="comparison-column highlight">
              <h3 className="comparison-title positive">Officine del Cuore</h3>
              <ul className="comparison-list">
                <li>Selezione accurata e personalizzata</li>
                <li>Profili verificati e certificati</li>
                <li>Presentazioni mirate e compatibili</li>
                <li>Consulenti umani che vi ascoltano</li>
                <li>Accompagnamento verso risultati concreti</li>
                <li>Massima riservatezza, nulla di pubblico</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Button Section */}
      <section className="section-elegant bg-warm-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <a href="tel:+393292626152">
            <Button size="lg" className="btn-primary btn-large">
              Chiama Ora
            </Button>
          </a>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section-elegant">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="section-title text-center mb-12">
            Le parole di chi ci ha scelto su Google
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <Card key={`testimonial-${index}-${testimonial.substring(0, 20)}`} className="testimonial-card">
                <CardContent className="p-6">
                  <div className="flex gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={`star-${index}-${i}`} className="w-5 h-5 fill-gold text-gold" />
                    ))}
                  </div>
                  <p className="text-sm text-burgundy/80 leading-relaxed italic">
                    "{testimonial}"
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="cta-title">
            Pronti a Incontrare la Persona Giusta?
          </h2>
          <p className="cta-description">
            Il primo passo è un colloquio conoscitivo riservato, senza impegno. 
            Parliamo delle vostre aspettative e valutiamo insieme se possiamo aiutarvi.
          </p>
          <Link to="/contatti">
            <Button size="lg" className="btn-primary btn-large mt-6">
              Prenota il Tuo Colloquio Gratuito
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
          <p className="privacy-note">
            <Shield className="inline mr-2" size={16} />
            I vostri dati sono trattati con massima riservatezza
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
